export default "./images/survio-25Nt_-assets-members-activity.svg";